import {
  createColumnHelper,
  createSortedRowModel,
  rowSortingFeature,
  sortFn_alphanumeric,
  sortFn_text,
  tableFeatures,
  type ColumnDef,
  type RowData,
  columnFilteringFeature,
  createFilteredRowModel,
  filterFn_includesString,
  filterFn_equals,
  rowPaginationFeature,
  createPaginatedRowModel,
} from '@tanstack/react-table';

export type DataTableColumnMeta = {
  // Header/cell text-align override. Every column right-aligns by default
  // (matches the CSS's last-child rule); a long free-text last column (e.g.
  // Feedback's message) wants 'left' instead.
  align?: 'left' | 'right';
  filterType?: 'text' | 'select' | 'none';
  filterOptions?: { label: string; value: string }[];
  placeholder?: string;
};

// Shared feature set for every admin datatable (Users, Grant History, Feedback,
// per-user Video Jobs) — sorting, client-side filtering, and pagination.
export const dataTableFeatures = tableFeatures({
  rowSortingFeature,
  sortedRowModel: createSortedRowModel(),
  sortFns: { alphanumeric: sortFn_alphanumeric, text: sortFn_text },
  columnFilteringFeature,
  filteredRowModel: createFilteredRowModel(),
  filterFns: {
    includesString: filterFn_includesString,
    equals: filterFn_equals,
  },
  rowPaginationFeature,
  paginatedRowModel: createPaginatedRowModel(),
  columnMeta: {} as DataTableColumnMeta,
});

export type DataTableColumn<T extends RowData> = ColumnDef<typeof dataTableFeatures, T>;

export function createDataTableColumns<T extends RowData>() {
  return createColumnHelper<typeof dataTableFeatures, T>();
}
